import { render, staticRenderFns } from "./MyMember.vue?vue&type=template&id=556bd34a&scoped=true"
import script from "./MyMember.vue?vue&type=script&lang=js"
export * from "./MyMember.vue?vue&type=script&lang=js"
import style0 from "./MyMember.vue?vue&type=style&index=0&id=556bd34a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556bd34a",
  null
  
)

export default component.exports